import { render, staticRenderFns } from "./my-complaintRecords.vue?vue&type=template&id=1478dc72&scoped=true&"
import script from "./my-complaintRecords.vue?vue&type=script&lang=js&"
export * from "./my-complaintRecords.vue?vue&type=script&lang=js&"
import style0 from "./my-complaintRecords.vue?vue&type=style&index=0&id=1478dc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478dc72",
  null
  
)

component.options.__file = "my-complaintRecords.vue"
export default component.exports